export default "/static/dashboard/build/app/img/v2/c3c96245888b97d3dc81511564db2e0a.png";